"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderDropdownButton = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _layout = require("../../layout");

var _button = require("../../button");

var _utils = require("../../utils");

var _ = require("./");

var _core = require("@emotion/core");

var SpanRow = _layout.Row.withComponent('span', {
  target: "epukfvx0"
});

var PageHeaderDropdownButtonBase = (0, _context.styledWithTheme)(_button.Button)(function (_ref) {
  var theme = _ref.theme;
  return "\n  background-color: ".concat(theme.selectors.color('white'), ";\n  font-weight: ").concat(theme.selectors.fontWeight('regular'), ";\n  \n  :hover {\n    background-color: ").concat(theme.selectors.color('primaryTint'), ";\n    text-decoration: none;\n  }\n\n  &:focus,\n  &:visited,\n  &:active {\n    outline-offset: -2px;\n  }\n");
});

var PageHeaderDropdownButtonWithoutDocs = function PageHeaderDropdownButtonWithoutDocs(_ref2) {
  var dataTestId = _ref2.dataTestId,
      children = _ref2.children,
      icon = _ref2.icon,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref2, ["dataTestId", "children", "icon"]);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeaderDropdownButton',
    dataTestId: dataTestId
  });
  return (0, _core.jsx)(PageHeaderDropdownButtonBase, (0, _extends2.default)({
    tertiary: true
  }, buttonProps, dataTestProps), (0, _core.jsx)(SpanRow, {
    alignItems: "center",
    gridGap: icon ? 'S100' : undefined,
    height: "100%",
    padding: [16, 24]
  }, !!icon && icon, !!children && children));
};

var PageHeaderDropdownButton = (0, _stencilReactDesc.describe)(PageHeaderDropdownButtonWithoutDocs).description('Button dropdown item for PageHeader.');
exports.PageHeaderDropdownButton = PageHeaderDropdownButton;
PageHeaderDropdownButton.displayName = 'PageHeaderDropdownButton';
PageHeaderDropdownButton.propTypes = (0, _objectSpread2.default)({}, _button.Button.describedPropTypes, (0, _utils.pick)(_.PageHeaderButton.describedPropTypes, ['dataTestId', 'children', 'icon']));